const AuditingToolReportActionTypes = {
	/** ***************** GET AUDITING TOOL REPORT START *********************** */
	GET_AUDITING_TOOL_REPORT_LIST_START: 'GET_AUDITING_TOOL_REPORT_LIST_START',
	GET_AUDITING_TOOL_REPORT_LIST_SUCCESS: 'GET_AUDITING_TOOL_REPORT_LIST_SUCCESS',
	GET_AUDITING_TOOL_REPORT_LIST_FAILURE: 'GET_AUDITING_TOOL_REPORT_LIST_FAILURE',
	GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET: 'GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET',
	GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED:
		'GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_CHANGED',
	/** ***************** GET AUDITING TOOL REPORT END *********************** */
};
export default AuditingToolReportActionTypes;
